import React from "react";
import * as S from "./BoxMostRead.sc";
import Article from "../ImportantArticles/Article";

const BoxMostRead = ({ articles }) => {
  return (
    <S.Container>
      <S.Header>Najczęściej czytane</S.Header>
      {articles.map((article) => (
        <Article
          key={article.id}
          title={article.title}
          category={article.category?.name || ""}
          url={article.get_external_url}
          theme="classic"
        />
      ))}
    </S.Container>
  );
};

export default BoxMostRead;
